import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { ISceneIconProps, SceneIconVariant } from '.';

function BubblechatSceneIcon({
  color,
  className,
  size = 16,
  rotate,
  flip,
  variant = SceneIconVariant.DEFAULT,
}: ISceneIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SceneIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path
            d="M2.86393 7.09863H10.8639C12.121 7.09863 12.7496 7.09863 13.1401 7.48916C13.5306 7.87968 13.5306 8.50822 13.5306 9.7653V10.432C13.5306 12.3176 13.5306 13.2604 12.9448 13.8462C12.359 14.432 11.4162 14.432 9.5306 14.432H6.86393C4.97831 14.432 4.03551 14.432 3.44972 13.8462C2.86393 13.2604 2.86393 12.3176 2.86393 10.432V7.09863Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M9.47622 1.87595L6.29743 2.72771C6.31156 2.78474 6.31579 2.84525 6.30842 2.90705L5.90571 6.28359L9.09194 5.42984C9.07389 5.36744 9.06779 5.30047 9.07596 5.23192L9.47622 1.87595Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M10.0914 5.16204L12.3631 4.55335C12.5127 4.51326 12.5875 4.49322 12.6464 4.46418C12.8882 4.34492 13.0344 4.09173 13.0167 3.82266C13.0124 3.75714 12.9924 3.68234 12.9523 3.53273C12.8321 3.08391 12.7719 2.8595 12.6848 2.68283C12.327 1.95732 11.5674 1.51878 10.7602 1.57169C10.6781 1.57707 10.5911 1.59071 10.4849 1.61353C10.4976 1.6684 10.5012 1.72636 10.4941 1.7855L10.0914 5.16204Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M4.90626 6.55139C4.88822 6.48899 4.88211 6.42202 4.89029 6.35347L5.29054 2.9975L5.22181 3.01592C4.01812 3.33845 3.41627 3.49971 3.03733 3.87865C2.78909 4.1269 2.61056 4.43612 2.5197 4.77523C2.38099 5.29287 2.54226 5.89471 2.86479 7.0984L4.90626 6.55139Z"
            fill={theme.color.icon.icon_2}
          />
        </svg>
      )}
      {variant === SceneIconVariant.CARTOON && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill={theme.color.line.line_1} />
          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke={theme.color.line.line_1} />
          <path
            d="M9.33333 15.166H19.3333C20.9047 15.166 21.6904 15.166 22.1785 15.6542C22.6667 16.1423 22.6667 16.928 22.6667 18.4993V19.3327C22.6667 21.6897 22.6667 22.8682 21.9344 23.6004C21.2022 24.3327 20.0237 24.3327 17.6667 24.3327H14.3333C11.9763 24.3327 10.7978 24.3327 10.0656 23.6004C9.33333 22.8682 9.33333 21.6897 9.33333 19.3327V15.166Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M17.5987 8.63767L13.6252 9.70236C13.6429 9.77365 13.6482 9.84929 13.6389 9.92654L13.1356 14.1472L17.1183 13.08C17.0958 13.002 17.0882 12.9183 17.0984 12.8326L17.5987 8.63767Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M18.3677 12.7453L21.2072 11.9844C21.3942 11.9343 21.4878 11.9092 21.5614 11.8729C21.8637 11.7239 22.0464 11.4074 22.0243 11.0711C22.019 10.9892 21.9939 10.8956 21.9438 10.7086C21.7935 10.1476 21.7183 9.86709 21.6094 9.64626C21.1622 8.73938 20.2127 8.1912 19.2037 8.25733C19.101 8.26406 18.9923 8.28111 18.8595 8.30964C18.8754 8.37822 18.8799 8.45067 18.871 8.5246L18.3677 12.7453Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M11.8862 14.482C11.8637 14.404 11.8561 14.3203 11.8663 14.2346L12.3666 10.0396L12.2807 10.0626C10.7761 10.4658 10.0238 10.6674 9.55008 11.141C9.23978 11.4513 9.01662 11.8379 8.90304 12.2618C8.72966 12.9088 8.93124 13.6611 9.3344 15.1657L11.8862 14.482Z"
            fill={theme.color.icon.icon_2}
          />
        </svg>
      )}
    </i>
  );
}

export default BubblechatSceneIcon;
